import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetEmailStats as GetEmailStatsQuery} from 'nutshell-graphql-types';

import GET_EMAIL_STATS from './email-health/graphql/queries/email-stats-query.graphql';

export const useGetEmailStats = () => {
    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetEmailStatsQuery, Record<any, any>>(GET_EMAIL_STATS, {});

    return {
        emailStats: data && data.emailStats,
        includeAdditionalAutomationBoxes: Boolean(
            data && data.emailStats && data.emailStats.instanceHasConfiguredEmailAutomations
        ),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    };
};
